import { lazy } from 'react';

/** Открывает карточку версии приложения */
export const AppVersionDetailsPageAsync = lazy(() => import('./AppVersionDetails/AppVersionDetailsPage'));
